import { combineReducers } from 'redux';

import { localeReducer } from './locale';
import { overlaysReducer } from './overlays';

/**
* The userAgent state won't be set by anything
* other than the server on page load so there's
* no need for anything other than a passthru.
*/
const userAgentReducer = function(state = {}) {
  return state;
};

export default combineReducers({
  locale: localeReducer,
  userAgent: userAgentReducer,
  overlays: overlaysReducer,
});



// WEBPACK FOOTER //
// ../src/client/state/index.js